(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('VendorDetailController', VendorDetailController);

  /* ngInject */
  function VendorDetailController($state, $stateParams, Flash, config, sessionService, vendorService) {
    const vm = this;

    vm.config = config;
    vm.daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    vm.deleteVendor = deleteVendor;
    vm.id = $stateParams.id;
    vm.sessionService = sessionService;
    vm.unassignVendorRepresentative = unassignVendorRepresentative;
    vm.vendor = {};

    activate();

    function activate() {
      getVendor();
    }

    function deleteVendor() {
      vendorService(sessionService.getAuthToken()).destroy({ id: vm.id }, _ => {
        $state.go('application.vms.vendors');
        Flash.create('success', 'Vendor successfully deleted.');
        angular.element('#deleteVendorModal').modal('hide');
      });
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.vendor = response);
    }

    function unassignVendorRepresentative() {
      vendorService(sessionService.getAuthToken()).unassign_representative({ id: vm.id }, _ => {
        $state.reload();
        Flash.create('success', 'Vendor representative successfully successfully unassigned.');
        angular.element('#unassignRepresentativeModal').modal('hide');
      }, _ => {
        Flash.create('danger', 'An error occurred with the submission. Please try again later.');
        angular.element('#unassignRepresentativeModal').modal('hide');
      });
    }
  }
})();
